import { FocusEvent, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import * as amplitude from '@amplitude/analytics-browser';

import { Button, Input } from '@unified-checkout/design-system';
import { TrashCan } from '@unified-checkout/design-system/icons/index';

import type { IAdvancedOptionsProps } from '@app/dashboard/types/innerLayout/payment_links/single_quick_link';
import { SINGLE_PAYMENTS_FIELDS } from '@app/dashboard/constants/payment-links/single-payments';
import {
  SINGLE_PAYMENT_LINKS_EVENTS,
  SINGLE_PAYMENT_LINKS_EVENTS_PARAMS,
} from '@app/dashboard/constants/tracking_events/payment_links/single';
import { onFieldChangeHandler } from '@app/dashboard/utils/formValidations';

import styles from './reference-id.module.scss';

const ReferenceId = ({
  fields,
  setFields,
}: Omit<IAdvancedOptionsProps, 'fullPageStatus'>) => {
  const referenceRef = useRef('');

  const { t } = useTranslation();

  const referenceId = fields[SINGLE_PAYMENTS_FIELDS.REF_ID];

  const onChangeHandler = (value: string) => {
    onFieldChangeHandler(
      fields,
      setFields,
      SINGLE_PAYMENTS_FIELDS.REF_ID,
      value,
      () => {}
    );
  };

  const onFocusHandler = (e: FocusEvent<HTMLInputElement>) => {
    referenceRef.current = e.target.value;
  };

  const onBlurHandler = (e: FocusEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (value && value !== referenceRef.current) {
      amplitude.track(SINGLE_PAYMENT_LINKS_EVENTS.REFERENCE_ID_UPDATED, {
        [SINGLE_PAYMENT_LINKS_EVENTS_PARAMS.REF_ID_LENGTH]: value.length,
      });
    }
  };

  const handleDeleteReference = () => {
    onChangeHandler('');
  };

  return (
    <div className={styles['reference-id']}>
      <Input
        name={SINGLE_PAYMENTS_FIELDS.REF_ID}
        label={t(
          'innerLayout.paymentLinksCreationPages.singlePaymentLink.sections.advancedOptions.labels.reference'
        )}
        placeholder={t(
          'innerLayout.paymentLinksCreationPages.singlePaymentLink.sections.advancedOptions.placeholders.reference'
        )}
        onChange={(e) => onChangeHandler(e.target.value)}
        value={referenceId?.value || ''}
        error={referenceId?.errorMsg || ''}
        status={referenceId?.errorMsg ? 'error' : 'default'}
        onFocus={onFocusHandler}
        onBlur={onBlurHandler}
      />
      {/* <Button
        size="md"
        text={t(
          'innerLayout.paymentLinksCreationPages.singlePaymentLink.sections.advancedOptions.actions.removeDescription'
        )}
        onClickHandler={handleDeleteReference}
        variant="link"
        color="secondary"
        leadingIcon={TrashCan}
      /> */}
    </div>
  );
};

export default ReferenceId;
